import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `Input` — Schicht-1 primitive (FRONTEND_ARCHITEKTUR §1). The only renderer of a
 * `<input>` in features/pages (enforced by the ESLint no-raw-`<input>` rule).
 * Native input attributes (`type`, `placeholder`, `value`, `onChange`, …) pass
 * through; styling/a11y come from the pure `resolveInputProps`.
 */
import { forwardRef, useState } from "react";
import { resolveInputProps } from "./inputProps.js";
export const Input = forwardRef(function Input(props, ref) {
    const { size, invalid, disabled, className, type, value, onFocus, onBlur, onChange, ...rest } = props;
    const r = resolveInputProps({ size, invalid, disabled, className });
    const isControlledNumber = type === "number" && value !== undefined;
    const [numberFocused, setNumberFocused] = useState(false);
    const [numberEditText, setNumberEditText] = useState("");
    // Während der Eingabe darf ein kontrolliertes Zahlenfeld leer bleiben. Viele
    // Consumer speichern Number("") als 0; ohne diesen Puffer springt die 0
    // sofort zurück und lässt sich nicht durch Löschen neu eingeben.
    const displayedValue = isControlledNumber && numberFocused ? numberEditText : value;
    return (_jsx("input", { ref: ref, className: r.className, "data-size": r["data-size"], "aria-invalid": r["aria-invalid"], disabled: r.disabled, type: type, value: displayedValue, onFocus: (event) => {
            if (isControlledNumber) {
                setNumberEditText(value === null ? "" : String(value));
                setNumberFocused(true);
            }
            onFocus?.(event);
        }, onBlur: (event) => {
            if (isControlledNumber) {
                setNumberFocused(false);
            }
            onBlur?.(event);
        }, onChange: (event) => {
            if (isControlledNumber) {
                setNumberEditText(event.currentTarget.value);
            }
            onChange?.(event);
        }, ...rest }));
});
